import { __extends } from "tslib";
import { Subscriber } from '../Subscriber';
import { empty as emptyObserver } from '../Observer';
import { isSubscription } from '../Subscription';
export function toSubscriber(nextOrObserver, error, complete) {
    if (nextOrObserver) {
        if (isSubscriber(nextOrObserver)) {
            return nextOrObserver;
        }
        if (isObserver(nextOrObserver)) {
            return new FullObserverSubscriber(nextOrObserver);
        }
    }
    if (!nextOrObserver && !error && !complete) {
        return new Subscriber(emptyObserver);
    }
    return new Subscriber(nextOrObserver, error, complete);
}
function isObserver(value) {
    return value && typeof value.next === 'function' && typeof value.error === 'function' && typeof value.complete === 'function';
}
function isSubscriber(value) {
    return value instanceof Subscriber || (isObserver(value) && isSubscription(value));
}
var FullObserverSubscriber = (function (_super) {
    __extends(FullObserverSubscriber, _super);
    function FullObserverSubscriber(destination) {
        var _this = _super.call(this) || this;
        _this.destination = destination;
        return _this;
    }
    return FullObserverSubscriber;
}(Subscriber));
//# sourceMappingURL=toSubscriber.js.map